import {getSubmissions} from '@/containers/E4ImpactProjects/TabSections/Output/filterByEmployees';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many people does your business currently employ?
 * 
 * == baseline
 * jobs_t0_total_number
 * 
 * 
 * Survey: PROJECT- FINAL IMPACT
 * Question: How many people does your business employ?
 * 
 * == final
 * jobs_t1_total_number
 * 
 * @param props 
 * @returns 
 */
export const jobCreatedTotalCalculation = (props: any) => {
    const positiveSubmissions = getSubmissions(props);

    const baselineTotalEmployees = positiveSubmissions.reduce(
        (acc, {baselineSubmission}: any) => acc + (Number(baselineSubmission.jobs_t0_total_number) || 0),
        0
    );
    const finalTotalEmployees =  positiveSubmissions.reduce(
        (acc, {finalSubmission}: any) => acc + (Number(finalSubmission.jobs_t1_total_number) || 0),
        0
    );

    return finalTotalEmployees - baselineTotalEmployees;
}